import { render, staticRenderFns } from "./TabSideBridge.vue?vue&type=template&id=5bf9183d&scoped=true&"
import script from "./TabSideBridge.vue?vue&type=script&lang=js&"
export * from "./TabSideBridge.vue?vue&type=script&lang=js&"
import style0 from "./TabSideBridge.vue?vue&type=style&index=0&id=5bf9183d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9183d",
  null
  
)

export default component.exports